const units = (units = [], action) => {
  switch (action.type) {
    case 'FETCH_UNITS':
      return action.payload
    default:
      return units
  }
}
export default units
